import Component from './Create.vue';

export default {
  install(Vue) {
    Vue.component('BkfDialogEntityCreate', Component);
  },
};
